<template lang="html">
	<div :class='locked ? "index-news locked" : "index-news"'>
		<!-- <pre>{{data}}</pre> -->

		<template v-if='!items.length'>
			{{ data.nothing_to_show }}
		</template>

		<template v-else>
			<div class="row">
				<div class="cols s_24 m_12 l_8" v-for='item in items'>
					<div class="newsItem">
						<a :href='item.detail_link' class="imgContainer">
							<span class="bgimg" :style='`background-image: url("${item.image_src}")`'></span>
						</a>

						<div class="absContainer">
							<p class="text">{{item.text}}</p>
							<div class="bottomInfo">
								<p v-if="item.date" class="date">{{ item.date }}
									<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
										<path d="M12 2C6.46 2 2 6.48 2 12s4.47 10 10 10c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
										<path fill="none" d="M0 0h24v24H0z"/>
										<path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
									</svg>
								</p>
								<p v-if="item.seen" class="seen">
									{{ item.seen }}
									<svg  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
										 <path d="M0 0h24v24H0z" fill="none"/>
										 <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
									</svg>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
module.exports = {
	props: ['data', 'merge', 'locked'],

	data() {
		return {
			items: []
		}
	},

	watch: {
		data() {
			// this.items = ;
			if(this.merge) {
				this.data.items.forEach(item => this.items.push(item));
			}
			else {
				this.items = this.data.items;
			}
		}
	},

	updated() {
		// if(!this.merge) {
		// 	// $('html, body').stop().animate({
		// 	// 	scrollTop: $(this.$el).offset().top - 100
		// 	// });
		// }
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.index-news {
	@include single-transition;

	&.locked {
		opacity: .5;
	}

	& + .Pager {
		display: none;
	}

	.newsItem{
		margin-bottom: 30px;
		position: relative;

		.imgContainer{
			display: block;
			width: 100%;
			height: 252px;
			position: relative;
			overflow: hidden;
			box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.2);
			.bgimg {
				display: block;
				position: absolute;
				z-index: 1;
				background-size: cover;
				background-position: center;
				border-radius: 2px;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				@include single-transition(all, 700ms, ease);
			}

			&:before{
				position: absolute;
				left: 0;
				top: 120px;
				width: 100%;
				height: 100%;
				content: "";
				// background-color: rgba(0,0,0,.1);
				background: url('#{$imgPathComponent}shadow-5.png') no-repeat center;
				background-size: 100% 100%;
				@include single-transition();
				z-index: 2;
			}

			&:hover{
				&:before{
					opacity: .9;
				}

				.bgimg {
					@include scale(1.05);
				}
			}
		}

		.absContainer{
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			padding: rem(25);
			z-index: 3;
			pointer-events: none;
			.text{
				color: white;
				font-size: rem(20);
				line-height: rem(26);
				letter-spacing: 0;
				font-family: $Circe_regular;
			}
			.bottomInfo{
				display: flex;
				font-size: rem(12);
				line-height: rem(22);
				letter-spacing: .001em;
				color: white;
				padding-top: 8px;
				p{
					padding-right: 20px;
					position: relative;
					color: white;
					svg{
						width: 16px;
						height: 14px;
						position: absolute;
						left: 0;
						top: calc(50% - 7px);
						fill: #fff;
					}
					&.date{
						font-weight: bold;
						padding-left: 20px;
					}
					&.seen{
						padding-left: 20px;
					}
				}
			}
		}


	}
}
</style>



// WEBPACK FOOTER //
// index-news.vue?54fef626